module.exports = __webpack_public_path__ + "web2.png?a497112a82daa25ab5a73d69ebeb15db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/web2.png
// module id = 77
// module chunks = 0